import Comp from './Router'

export default Comp
